// Entries badge on dt-card product cards.
//
// The product page's entries badge is the Clean Sweeps app block, which asks
// backend.cleansweeps.app for the sweepstake rules and computes entries in the
// browser. App blocks can't render inside a snippet, so cards use the same
// query (batched: one request for every card on the page) and the same formula,
// priced at the card's own displayed price. Membership multipliers depend on
// customer tags and are left to the product page.
(() => {
  if (window.dtCardEntriesLoaded) return;
  window.dtCardEntriesLoaded = true;

  const SHOP = 'gid://shopify/Shop/67903619281'; // scrnd6-pd, as the Clean Sweeps block hardcodes it
  const QUERY = `query Q($platform: String!, $platformId: String!, $productIds: [String!]) {
    sweepstakeDetailsByProductId(platform: $platform, platformId: $platformId, productIds: $productIds) {
      id entryManagement productsAllowedByDefault bonusEntriesDefault
      membershipProductMultOverride scheduledBonusValue scheduledBonusActive
      products(productIds: $productIds) { productId productAllowed productBonusEntries productMultiplier }
    }
  }`;
  const done = new WeakSet();

  const entriesFor = (detail, gid, cents) => {
    const em = JSON.parse(detail.entryManagement);
    const dollarSpent = parseFloat(em.dollarSpent);
    const bonus = Number(detail.scheduledBonusValue);
    const per = detail.scheduledBonusActive === true && Number.isFinite(bonus) && bonus > 0 ? bonus : parseFloat(em.entryPer);
    const round = em.roundUp !== undefined && !em.roundUp ? Math.floor : Math.ceil;
    const subtotal = cents / 100;
    const rule = (detail.products || []).find(p => p.productId === gid);
    if (rule) {
      if (!rule.productAllowed) return null;
      const mult = detail.membershipProductMultOverride ? 1 : (rule.productMultiplier ?? 1);
      return round((per / dollarSpent) * round(subtotal)) * mult + (rule.productBonusEntries || 0);
    }
    if (!detail.productsAllowedByDefault) return null;
    return round((per / dollarSpent) * round(subtotal)) + (detail.bonusEntriesDefault || 0);
  };

  const run = async () => {
    const els = [...document.querySelectorAll('[data-dt-entries]')].filter(el => !done.has(el));
    if (!els.length) return;
    els.forEach(el => done.add(el));
    const ids = [...new Set(els.map(el => 'gid://shopify/Product/' + el.dataset.dtEntries))];
    let details = [];
    try {
      for (let i = 0; i < ids.length; i += 50) {
        const res = await fetch('https://backend.cleansweeps.app/graphql', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ query: QUERY, variables: { platform: 'Shopify', platformId: SHOP, productIds: ids.slice(i, i + 50) } })
        });
        if (!res.ok) return;
        const { data } = await res.json();
        const list = (data && data.sweepstakeDetailsByProductId) || [];
        // Same pick as the product block: the "default" sweepstake, else the first.
        const detail = list.find(d => String(d.id) === 'default') || list[0];
        if (!detail) return;
        details.push(detail);
      }
    } catch (e) { return; } // no badge beats a wrong one
    const fmt = new Intl.NumberFormat();
    els.forEach(el => {
      const gid = 'gid://shopify/Product/' + el.dataset.dtEntries;
      const detail = details.find(d => (d.products || []).some(p => p.productId === gid)) || details[0];
      let n = null;
      try { n = entriesFor(detail, gid, parseInt(el.dataset.price, 10)); } catch (e) { n = null; }
      if (typeof n !== 'number' || !Number.isFinite(n) || n <= 0) return;
      el.textContent = (el.hasAttribute('data-from') ? 'From ' : '') + fmt.format(n) + ' entries';
      el.hidden = false;
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  document.addEventListener('shopify:section:load', run);
})();
